import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { experimentsSelectors } from '@wix/wix-experiments-redux';
import _includes from 'lodash/includes';
import s from './header.scss';
import { Text } from 'wix-style-react';
import { goToAutoBrief } from '../../utils/goToBrief';
import {
  ARENA_EXPLORE_URL,
  ARENA_HOW_IT_WORKS_URL,
  ARENA_GET_HIRED_URL,
  BASE_URL_MARKETPLACE,
} from '../../utils/constants';
import { location } from '../../fromWindow';
import { ServicesProvider } from '@wix/experts-common';

const defaultOrigin = 'https://www.wix.com';
let origin = location?.origin || defaultOrigin;
origin =
  _includes(origin, '.editorx.com') || _includes(origin, 'manage.wix.com')
    ? defaultOrigin
    : origin;

const mapStateToProps = ({ experiments }) => ({
  addGetHiredLinkInMenu: experimentsSelectors({ experiments }).enabled(
    'specs.experts.GetHiredLinkInMenu',
  ),
  findMeExpertToTheRight: experimentsSelectors({ experiments }).enabled(
    'specs.experts.findMeExpertInMenuToTheRight',
  ),
});
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpen: false,
    };
  }

  render() {
    const { t, addGetHiredLinkInMenu, findMeExpertToTheRight } = this.props;
    const { isMenuOpen } = this.state;
    const handleNavLinkClicked = () => {
      this.setState({ isMenuOpen: false });
    };

    return (
      <header className={s.header} data-hook="header-container">
        <a
          data-hook="header-logo"
          className={s.logo}
          href={`${origin}${BASE_URL_MARKETPLACE}`}
          onClick={e => {
            handleNavLinkClicked(e);
          }}
        >
          {this.context.services.isInternal && (
            <span
              data-hook="is-internal-sign"
              style={{
                backgroundColor: 'red',
                color: 'white',
                position: 'absolute',
                bottom: '5px',
              }}
            >
              INTERNAL
            </span>
          )}
        </a>
        <a
          className={s.menu}
          onClick={() => {
            this.setState({ isMenuOpen: !isMenuOpen });
          }}
        />
        <nav className={`${s.nav} ${isMenuOpen ? s.open : ''}`}>
          <div
            data-hook="header-nav-link-wraper-findmeexpert"
            className={`${s.linkWrapper} ${
              findMeExpertToTheRight ? s.hideInDesktop : ''
            }`}
          >
            <NavLink
              data-hook="header-nav-link-findmeexpert"
              className={s.link}
              activeClassName={s.active}
              to="/find-me-expert"
              onClick={e => {
                e.preventDefault();
                this.context.services.withBI({
                  evid: 157,
                  typeid: 1,
                  origin: 'top menu',
                });
                goToAutoBrief({
                  entry: 'generalMenu',
                  categoryId: 1,
                  serviceId: 1,
                  origin: 'arenahomeheader',
                });
                handleNavLinkClicked(e);
              }}
            >
              <Text weight="thin" size="medium" secondary={false} light={false}>
                {findMeExpertToTheRight
                  ? t(`header-nav-link-find-a-proffesional`)
                  : t(`header-nav-link-findmeexpert`)}
              </Text>
            </NavLink>
          </div>
          <div
            data-hook="header-nav-link-wraper-explore"
            className={s.linkWrapper}
          >
            <NavLink
              data-hook="header-nav-link-explore"
              className={s.link}
              activeClassName={s.active}
              to={ARENA_EXPLORE_URL}
              onClick={e => {
                handleNavLinkClicked(e);
              }}
            >
              <Text weight="thin" size="medium" secondary={false} light={false}>
                {t(`header-nav-link-explore`)}
              </Text>
            </NavLink>
          </div>
          <div data-hook="header-nav-link-wraper-hiw" className={s.linkWrapper}>
            <a
              data-hook="header-nav-link-hiw"
              className={s.link}
              href={`${origin}${BASE_URL_MARKETPLACE}${ARENA_HOW_IT_WORKS_URL}`}
              onClick={e => {
                this.context.services.withBI({
                  evid: 158,
                  typeid: 1,
                  origin: 'top menu',
                });
                handleNavLinkClicked(e);
              }}
            >
              <Text weight="thin" size="medium" secondary={false} light={false}>
                {t(`header-nav-link-hiw`)}
              </Text>
            </a>
          </div>
          {addGetHiredLinkInMenu && (
            <div
              data-hook="header-nav-link-wraper-gethired"
              className={s.linkWrapper}
            >
              <a
                data-hook="header-nav-link-gethired"
                className={s.link}
                href={`${origin}${BASE_URL_MARKETPLACE}${ARENA_GET_HIRED_URL}`}
                onClick={e => {
                  handleNavLinkClicked(e);
                }}
              >
                <Text
                  weight="thin"
                  size="medium"
                  secondary={false}
                  light={false}
                >
                  {t(`header-nav-link-gethired`)}
                </Text>
              </a>
            </div>
          )}
          {findMeExpertToTheRight && (
            <div
              data-hook="header-nav-link-wraper-proffesional"
              className={`${s.linkWrapper} ${s.linkRightBlackWrapper}`}
            >
              <NavLink
                data-hook="header-nav-link-proffesional"
                className={s.link}
                activeClassName={s.active}
                to="/find-me-expert"
                onClick={e => {
                  e.preventDefault();
                  this.context.services.withBI({
                    evid: 157,
                    typeid: 1,
                    origin: 'top menu',
                  });
                  goToAutoBrief({
                    entry: 'generalMenu',
                    categoryId: 1,
                    serviceId: 1,
                    origin: 'arenahomeheader',
                  });
                  handleNavLinkClicked(e);
                }}
              >
                <Text
                  weight="thin"
                  size="medium"
                  secondary={false}
                  light={true}
                >
                  {t(`header-nav-link-find-a-proffesional`)}
                </Text>
              </NavLink>
            </div>
          )}
        </nav>
      </header>
    );
  }
}

Header.contextTypes = ServicesProvider.childContextTypes;

const ConnectedHeader = connect(mapStateToProps, {})(Header);

export default translate()(ConnectedHeader);
